export default __webpack_public_path__ + "static/media/cc-logo.0a139a33.svg";